import { connect } from 'react-redux';
import UserRoleSpecificContent from './UserRoleSpecificContent';

const mapStateToProps = ({ user: { data: userData }, userGroups: { activeADGroup } }) => {
  const props = {};

  if (userData.isSuperUser) {
    props.__ADGroup__ = activeADGroup;
  } else {
    // TODO: We pick the 1st item in group list. So, we might need to come up with smarter solution in the future
    [props.__ADGroup__] = userData.groups;
  }

  return props;
};

export default connect(mapStateToProps)(UserRoleSpecificContent);
